// extracted by mini-css-extract-plugin
export default {"imagePosition":"CardUser_imagePosition__puaXu","imageSize":"CardUser_imageSize__5efiW","error":"CardUser_error__WlUyz"};